module.exports = __webpack_public_path__ + "static/fonts/iconfont.78f72803.woff2";